import { FC, ReactNode } from 'react';
import './DropdownModal.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
}

const DropdownModal: FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="dropdownmodal-overlay">
      <div className="dropdownmodal-content">
        {title && <h4 className="dropdownmodal-title">{title}</h4>}
        <button className="dropdownmodal-close" onClick={onClose}>
          &times;
        </button>
        <div className="dropdownmodal-body">{children}</div>
      </div>
    </div>
  );
};

export default DropdownModal;
